export default "__VITE_ASSET__DO8CgD9K__"